<script lang="typescript">
    import { fade } from "svelte/transition"

    export let open = false
    export let closeOnClick = true
    export let closeOnClickOutside = true
    export let style = ""

    let oElem
    let tElem

    function onPageClick(e) {
        if (
            !closeOnClickOutside ||
            e.target === oElem ||
            e.target === tElem ||
            oElem?.contains(e.target) ||
            tElem?.contains(e.target)
        )
            return
        open = false
    }

    let oWidth: number
    let oHeight: number
    let innerHeight: number
    let innerWidth: number

    $: if (oElem) {
        if (oElem.offsetTop + oHeight > innerHeight) {
            oElem.style.top = innerHeight - oHeight + "px"
        }
        if (oElem.offsetLeft + oWidth > innerWidth) {
            oElem.style.left = innerWidth - oWidth + "px"
        }
    }
</script>

<span
    bind:this="{tElem}"
    on:click|stopPropagation="{() => {
        open = true
    }}"
>
    <slot name="trigger" />
</span>

{#if open}
    <div
        class="overlay"
        bind:this="{oElem}"
        bind:clientHeight="{oHeight}"
        bind:clientWidth="{oWidth}"
        transition:fade="{{ duration: 100 }}"
        style="{style}"
        on:click|stopPropagation="{() => {
            if (closeOnClick) {
                open = false
            }
        }}"
    >
        <slot name="content" />
    </div>
{/if}

<svelte:body on:click="{onPageClick}" />
<svelte:window bind:innerHeight bind:innerWidth />
